import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function groupBy<TValue, TKey extends keyof TValue>(
	arr: TValue[],
	key: TKey,
): Record<string, TValue[]> {
	return arr.reduce(
		(acc, curr) => {
			const k = curr[key] as string;
			acc[k] = [...(acc[k] || []), curr];
			return acc;
		},
		{} as Record<string, TValue[]>,
	);
}
